import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Worsening of the situation</div>
                                            <p>Left unaddressed, difficult situations (such as unreasonable
                                                behaviour) can get worse. If people aren’t given feedback about
                                                the impact of their behaviour they’re unlikely to change. Also,
                                                your resentment or irritation will probably increase or even
                                                lead to some outburst which, at best, you’ll regret or, at
                                                worst, could be extremely detrimental, both immediately and
                                                long-term.</p>
                                            <div className="border_subtitle">Poor relationships cost money</div>
                                            <p>If relationships break down because no one’s addressing a
                                                particular issue, one or more of those involved may even quit
                                                their jobs, with obvious financial and other consequences. Or,
                                                in situations where people want to leave but feel unable or
                                                disinclined to, the effect on productivity can be less
                                                immediate, but more damaging over time. People express distress
                                                or dissatisfaction at work in all kinds of ways, from
                                                withdrawing socially, working to rule or (‘oops!...’) wiping a
                                                database, and worse….</p>
                                            <div className="border_subtitle">‘Groupthink’</div>
                                            <p>This is when the majority view or behaviour in a group inhibits
                                                individuals within it from voicing or acting on their own better
                                                judgement. The causes of major disasters are often traced back
                                                to someone who ‘thought something wasn’t quite right about that,
                                                surely?’ but said or did nothing.</p>
                                            <div className="border_subtitle">Vilification</div>
                                            <p>Allowing your own or others’ ‘bad feeling’ to fester can spiral
                                                from being annoying or uncomfortable, to seriously damaging,
                                                even to the point – when such a situation occurs at managerial
                                                level – of actively resisting or quashing rivals’ suggestions,
                                                from which the entire company could benefit.</p>

                                            <div className="circle_title">
<span className="heading">
<img src={require('@images/browndot.jpg')} alt=""/></span>
                                                <span
                                                    className="heading">THE ‘PREPARE, ADDRESS, FOLLOW-UP’ APPROACH</span>
                                            </div>

                                            <p>To successfully manage a difficult conversation, it’s important
                                                to fully prepare for it. The model below provides a simple and
                                                useful ‘map’ for preparing for, and conducting our trickier
                                                encounters, and then following them up – or smoothing things out
                                                afterwards.</p>
                                            <p>It’s important, too, to separate out the two different elements
                                                of the conversation: ‘what happened’, (for example: ‘I heard you
                                                say something about the way so-and-so looked, at work’) and ‘how
                                                do you feel about that’ (for example: ‘it made me feel
                                                uncomfortable’). Try to filter out the emotional aspects but
                                                still be honest about how you’re feeling.</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/communicate_image.png')}
                                                    alt=""/>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}